import React, { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { useSocket } from "../../context/SocketContext";
import { addNotification, fetchUnreadCount } from "../../redux/slices/notificationSlice";
import { toast } from "react-toastify";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
  Avatar,
  AppBar,
  Toolbar,
} from "@mui/material";
import {
  Settings,
  Menu as MenuIcon,
  Logout,
  Dashboard as DashboardIcon,
  Category as CategoryIcon,
  RestaurantMenu as MenuIconMUI, 
  ShoppingCart as OrdersIcon,
  QrCode2 as QrCodeIcon,
  Person as ProfileIcon,
  Restaurant as RestaurantIcon,
 LocalOffer as LocalOfferIcon,
PhotoLibrary as PhotoLibraryIcon,
Assessment,
RestaurantMenu
} from "@mui/icons-material";
 import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import AssessmentIcon from '@mui/icons-material/Assessment'
// import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import NotificationBell from "../../components/common/NotificationBell";



const OwnerLayout = () => {
  const drawerWidth = 230;
  const dispatch = useDispatch();
  const { socket } = useSocket();
  const audioRef = useRef(null);
   const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const role = user?.role
  ? user.role.charAt(0).toUpperCase() + user.role.slice(1).toLowerCase()
  : "Owner"; // Default to OWNER if role is not available
  const isDeliveryEnabled = Boolean(user?.delivery);

const isOwner = user?.role === "OWNER";


  const ownerMenuItems = [
  { 
    text: "Dashboard", 
    icon: <DashboardIcon />, 
    path: "/owner/dashboard" 
  }, 
   { 
    text: "Category", 
    icon: <CategoryIcon />, 
    path: "/owner/category" 
  }, 
  { 
    text: "Menu", 
    icon: <MenuIconMUI />, 
    path: "/owner/menu" 
  },
  { 
    text: "Orders", 
    icon: <OrdersIcon />, 
    path: "/owner/orders" 
  },
   { 
    text: "Offers", 
    icon: <LocalOfferIcon />, 
    path: "/owner/offers" 
  },
  { 
    text: "Home Banner", 
    icon: <PhotoLibraryIcon />, 
    path: "/owner/banner" 
  },
  
  { 
    text: "QR Code", 
    icon: <QrCodeIcon />, 
    path: "/owner/qr" 
  },
  { 
    text: "Staff Management", 
    icon: <ProfileIcon />, 
    path: "/owner/staff" 
  },
  //  { 
  //   text: "COD Settlements", 
  //   icon: <AccountBalanceWalletIcon />, 
  //   path: "/owner/cod-settlements" 
  // },

  // { 
  //   text: "Commission", 
  //   icon: <AssessmentIcon />, 
  //   path: "/owner/commission" 
  // },

  // 🔥 SIRF TABHI SHOW HONGE JAB OWNER PROFILE ME delivery: true HOGA
  ...(isDeliveryEnabled
    ? [
        {
          text: "COD Settlements",
          icon: <AccountBalanceWalletIcon />,
          path: "/owner/cod-settlements",
        },
        {
          text: "Commission",
          icon: <AssessmentIcon />,
          path: "/owner/commission",
        },
      ]
    : []),

  { 
    text: "Billing", 
    icon: <Assessment />, 
    path: "/owner/billing" 
  },
  // { 
  //   text: "Payments List", 
  //   icon: <ProfileIcon />, 
  //   path: "/owner/payments" 
  // },
];

  const handleProfileIconClick = (event) => {
    setProfileMenuAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  const handleOpenLogoutModal = () => {
    setOpenLogoutModal(true);
    setProfileMenuAnchor(null);
  };

  const handleCloseLogoutModal = () => setOpenLogoutModal(false);

  // Sound initialization
  useEffect(() => {
    audioRef.current = new Audio("/sounds/notification.mp3");
    audioRef.current.volume = 1.0;
  }, []);

    const handleLogout = () => {
    dispatch(logout());
    handleCloseLogoutModal();
    navigate("/login");
  };

  const playNotificationSound = () => {
    try {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch((err) => {
          console.warn("Autoplay audio blocked or error:", err);
        });
      }
    } catch (e) {
      console.error("Audio error:", e);
    }
  };

  useEffect(() => {
    if (!socket) return;

    // 1. New Order Alert (Har page par trigger hoga)
    const handleNewOrder = (data) => {
      const order = data?.order || data;
      const customerName = order.customer?.name || "Customer";
      const total = order.orderSummary?.totalAmount || order.totalAmount || 0;

      // 🔊 Sound play
      playNotificationSound();

      // 🔔 Redux Notification Count & List me add karo
      dispatch(
        addNotification({
          _id: new Date().getTime().toString(),
          // title: "🆕 Naya Order Aaya Hai!",
          // message: `${customerName} ne ₹${Number(total).toFixed(2)} ka order place kiya hai.`,
          // createdAt: new Date().toISOString(),
          title: "New Order Received! 🔔",
          message: `${customerName} placed an order of ₹${Number(total).toFixed(2)}.`,
          createdAt: new Date().toISOString(),
          read: false,
          data: { orderId: order._id },
        })
      );

      // // Toast alert
      // toast.info(`🔔 Naya Order #${order._id?.slice(-6)?.toUpperCase()} mila! (₹${total})`, {
      //   position: "top-right",
      //   autoClose: 5000,
      // });

      // Toast alert
      toast.info(`🔔 New Order #${order._id?.slice(-6)?.toUpperCase()} received! (₹${total})`, {
        position: "top-right",
        autoClose: 5000,
      });

      // Browser Native notification agar tab minimize ho
      if (document.hidden && Notification.permission === "granted") {
        // new Notification("🆕 Naya Order Aaya!", {
        new Notification("New Order Received! 🔔", {
          body: `${customerName} - ₹${total}`,
          icon: "/logo192.png",
          tag: `order-${order._id}`,
        });
      }
    };

    // 2. Order Cancelled Alert
    const handleOrderCancelled = (data) => {
      playNotificationSound();
      // toast.error(`❌ Order #${data.orderId?.slice(-6)?.toUpperCase()} cancel ho gaya hai!`);
      toast.error(`❌ Order #${data.orderId?.slice(-6)?.toUpperCase()} was cancelled by customer.`);
      dispatch(fetchUnreadCount());
    };

    socket.on("new-order", handleNewOrder);
    socket.on("order-cancelled", handleOrderCancelled);

    return () => {
      socket.off("new-order", handleNewOrder);
      socket.off("order-cancelled", handleOrderCancelled);
    };
  }, [socket, dispatch]);

  const drawerContents = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Top Logo Section */}
      <Box
        onClick={() => navigate("/owner/dashboard")}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 3,
          py: 2,
          cursor: "pointer",
          textDecoration: "none",
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {/* <RestaurantIcon sx={{ fontSize: 40, color: "#0b4064" }} /> */}
          <RestaurantMenu sx={{ fontSize: 40, color: "#0b4064" }} />
          <Box>
            <Typography variant="h6" sx={{ color: "#0b4064", fontWeight: 700 }}>
              RestaurantWala
            </Typography>
            <Typography variant="caption" sx={{ color: "#7a869a" }}>
              Restaurant {role}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ flexShrink: 0 }} />
      
      {/* Dashboard Title Section */}
      <Box sx={{ px: 2, py: 1.5, flexShrink: 0 }}>
        <Typography
          sx={{
            mb: 1,
            fontWeight: 600,
            color: "#2e4254",
            fontSize: 15,
            letterSpacing: 0.5,
            flexShrink: 0,
          }}
        >
          {role} Dashboard
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#7a869a",
            display: "block",
          }}
        >
          Manage your restaurant efficiently
        </Typography>
      </Box>
      
      <Divider sx={{ flexShrink: 0 }} />

      {/* Menu Items List - Scrollable Section */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "2px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }}
      >
        <List sx={{ py: 0 }}>
          {ownerMenuItems.map(({ text, icon, path }) => (
            <ListItem
              button
              key={text}
              selected={location.pathname === path}
              sx={{
                py: 1,
                mx: 1,
                my: 0.5,
                borderRadius: 2,
                color: "#2e4254",
                background: location.pathname === path ? "#f2f3f7" : "none",
                cursor: "pointer",
                transition: "all 0.2s ease",

                "&:hover": {
                  background: "#0b4064",
                  color: "#fff",
                  "& .MuiListItemIcon-root": {
                    color: "#fff",
                  },
                },

                fontWeight: location.pathname === path ? 700 : 600,
                maxWidth: "100%",
                overflowX: "hidden",
              }}
              onClick={() => {
                navigate(path, { replace: true });
                if (isMobile) setMobileOpen(false);
              }}
            >
              <ListItemIcon
                sx={{
                  color: location.pathname === path ? "#0b4064" : "#2e4254",
                  minWidth: 0,
                  pr: 1,
                  transition: "color 0.2s ease",
                }}
              >
                {icon}
              </ListItemIcon>

              <ListItemText
                primary={text}
                primaryTypographyProps={{
                  fontWeight: location.pathname === path ? 700 : 600,
                  fontSize: 15,
                  letterSpacing: 0.2,
                  sx: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Bottom User Info - Fixed at Bottom */}
      <Box
        sx={{
          mt: "auto",
          px: 2,
          py: 2,
          borderTop: "1px solid #ededed",
          display: { xs: "none", sm: "none", md: "flex" },
          alignItems: "center",
          gap: 1.5,
          cursor: "pointer",
          background: "#fff",
          flexShrink: 0,
          minHeight: 70,
        }}
        onClick={() => navigate("/owner/profile", { replace: true })}
      >
        {/* Avatar */}
        <Avatar
          alt={user?.restaurantName || "Restaurant"}
          src={user?.profileImage?.url || "https://via.placeholder.com/60"}
          sx={{
            width: 38,
            height: 38,
            borderRadius: "50%",
            background: "#0b4064",
            color: "#fff",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14,
            flexShrink: 0,
            "& img": {
              borderRadius: "50%",
            },
          }}
        />

        {/* Restaurant Name & Info */}
        <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600,
              color: "#2e4254",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {user?.restaurantName || "My Restaurant"}
          </Typography>
          <Typography
            sx={{
              fontSize: 12,
              color: "#7a869a",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {role}: {user?.ownerName || "Admin"}
          </Typography>
        </Box>

        {/* Settings */}
        <IconButton size="small">
          <Settings sx={{ fontSize: 20, color: "#7a869a" }} />
        </IconButton>
      </Box>
    </Box>
  );

  return (
      <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
        minWidth: 0,
        overflowX: "hidden",
        background: "#f2f3f7",
        boxSizing: "border-box",
      }}
    >
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? mobileOpen : true}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            background: "#fff",
            borderRight: "1px solid #ededed",
            overflow: "hidden",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {drawerContents}
      </Drawer>
      
      <Box
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          width: "100%",
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        {/* Top Header */}
        <Box
          sx={{
            height: 60,
            background: "#fff",
            borderBottom: "1px solid #ededed",
            display: "flex",
            alignItems: "center",
            px: { xs: 2, sm: 4 },
            position: "sticky",
            top: 0,
            zIndex: 10,
            flexShrink: 0,
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          {isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={() => setMobileOpen(true)}
              size="large"
              aria-label="open drawer"
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          
          {/* Restaurant Name in Header (Desktop) */}
          {user?.restaurantName && (
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                whiteSpace: "nowrap",
                alignSelf: "center",
                color: "#0b4064",
                display: { xs: "none", sm: "flex" },
              }}
            >
              {user.restaurantName}
            </Typography>
          )}
          
          <Box sx={{ flexGrow: 1 }} />
          <span style= {{marginRight:"8px"}}><NotificationBell /> </span>
          
          {/* User Avatar and Menu */}
          <Avatar
            alt={user?.restaurantName || "Restaurant"}
            src={user?.profileImage?.url || "https://via.placeholder.com/60"}
            onClick={handleProfileIconClick}
            sx={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              background: "#0b4064",
              color: "#fff",
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 14,
              flexShrink: 0,
              cursor: "pointer",
              "& img": {
                borderRadius: "50%",
              },
            }}
          />
          
          <Menu
            anchorEl={profileMenuAnchor}
            open={Boolean(profileMenuAnchor)}
            onClose={handleProfileMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  cursor: "pointer",
                  background: "#fff",
                  flexShrink: 0,
                }}
                onClick={() => navigate("/owner/profile", { replace: true })}
              >
                <NotificationBell />
                <Avatar
                  alt={user?.restaurantName || "Restaurant"}
                  src={user?.profileImage?.url || "https://via.placeholder.com/60"}
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    background: "#0b4064",
                    color: "#fff",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 14,
                    flexShrink: 0,
                    "& img": {
                      borderRadius: "50%",
                    },
                  }}
                />

                <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#2e4254",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {user?.restaurantName || "My Restaurant"}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#7a869a",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {role}: {user?.ownerName || "Admin"}
                  </Typography>
                </Box>

                <IconButton size="small">
                  <Settings sx={{ fontSize: 20, color: "#7a869a" }} />
                </IconButton>
              </Box>
            </MenuItem>

            <Divider sx={{ my: 1 }} />
            <MenuItem
              onClick={handleOpenLogoutModal}
              sx={{
                py: 1.5,
                px: 2,
                fontSize: 14,
                color: "#dc2626",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                "&:hover": {
                  backgroundColor: "#fef2f2",
                },
              }}
            >
              <Logout sx={{ fontSize: 20, color: "#dc2626" }} />
              Logout
            </MenuItem>
          </Menu>
        </Box>

        {/* Logout Confirmation Dialog */}
        <Dialog open={openLogoutModal} onClose={handleCloseLogoutModal}>
          <DialogTitle>Logout</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to logout?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseLogoutModal}>Cancel</Button>
            <Button color="primary" variant="contained" onClick={handleLogout}>
              Logout
            </Button>
          </DialogActions>
        </Dialog>

        {/* Main Content Area */}
        <Box
          sx={{
            p: { xs: 1, sm: 2, md: 4 },
            width: "100%",
            mx: "auto",
            minHeight: "calc(100vh - 60px)",
            boxSizing: "border-box",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default OwnerLayout;